import React from "react";

const CustomerReviews = () => {
    const reviews = [
        { name: "Saugat Adhikari", role: "Kathmandu", review: "Found a reliable plumber within minutes. Really impressed!", img: "https://i.pravatar.cc/100?img=11", stars: 5 },
        { name: "Asmita Khadka", role: "Lalitpur", review: "Very smooth experience. Booking a service was super easy.", img: "https://i.pravatar.cc/100?img=25", stars: 5 },
        { name: "Prabin Gautam", role: "Pokhara", review: "Electrician arrived on time and fixed everything quickly.", img: "https://i.pravatar.cc/100?img=36", stars: 4 },
        { name: "Ritu Basnet", role: "Bhaktapur", review: "Helpful platform! Found nearby services instantly.", img: "https://i.pravatar.cc/100?img=14", stars: 5 },
        { name: "Sanjay Koirala", role: "Butwal", review: "Great for comparing service providers. Very useful for daily needs.", img: "https://i.pravatar.cc/100?img=48", stars: 4 },
        { name: "Nikita Shrestha", role: "Biratnagar", review: "Fast response and very friendly support team. Loved it!", img: "https://i.pravatar.cc/100?img=22", stars: 5 },
    ];

    // visibility per card position: 1 on mobile, 2 on tablet, 3 on desktop
    const colClass = ["col-12 col-md-6 col-lg-4", "col-md-6 col-lg-4 d-none d-md-block", "col-lg-4 d-none d-lg-block"];

    return (
        <div className="cr-section">
            <div className="container">
                <div className="text-center mb-2">
                    <span className="cr-eyebrow"><i className="bi bi-stars me-1"></i> Trusted by customers</span>
                </div>
                <h2 className="cr-title text-center mb-1">What our customers say</h2>
                <p className="cr-sub text-center mb-4">Real experiences from people using DialNepal every day</p>

                <div id="multiCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="3500">
                    <div className="carousel-inner">
                        {reviews.map((_, index) => (
                            <div key={index} className={`carousel-item ${index === 0 ? "active" : ""}`}>
                                <div className="row g-4 justify-content-center px-1 py-2">
                                    {[0, 1, 2].map((i) => {
                                        const item = reviews[(index + i) % reviews.length];
                                        return (
                                            <div className={colClass[i]} key={i}>
                                                <div className="cr-card">
                                                    <i className="bi bi-quote cr-quote"></i>
                                                    <p className="cr-text">{item.review}</p>
                                                    <div className="cr-stars">
                                                        {Array.from({ length: 5 }).map((_, s) => (
                                                            <i key={s} className={`bi ${s < item.stars ? "bi-star-fill" : "bi-star"}`}></i>
                                                        ))}
                                                    </div>
                                                    <div className="cr-user">
                                                        <img src={item.img} alt={item.name} className="cr-avatar" />
                                                        <div className="text-start">
                                                            <div className="cr-name">{item.name}</div>
                                                            <div className="cr-role">{item.role}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Indicators */}
                    <div className="carousel-indicators cr-dots">
                        {reviews.map((_, index) => (
                            <button
                                key={index}
                                type="button"
                                data-bs-target="#multiCarousel"
                                data-bs-slide-to={index}
                                className={index === 0 ? "active" : ""}
                                aria-label={`Slide ${index + 1}`}
                            ></button>
                        ))}
                    </div>

                    {/* Controls */}
                    <button className="carousel-control-prev cr-ctrl" type="button" data-bs-target="#multiCarousel" data-bs-slide="prev">
                        <span className="cr-ctrl-icon"><i className="bi bi-chevron-left"></i></span>
                    </button>
                    <button className="carousel-control-next cr-ctrl" type="button" data-bs-target="#multiCarousel" data-bs-slide="next">
                        <span className="cr-ctrl-icon"><i className="bi bi-chevron-right"></i></span>
                    </button>
                </div>
            </div>

            <style>{`
                .cr-section { padding: 56px 0; background: linear-gradient(180deg,#f7f9ff,#ffffff); }
                .cr-eyebrow { display:inline-block; background:#eef3ff; color:#2563eb; font-weight:600; font-size:.8rem; padding:5px 14px; border-radius:30px; }
                .cr-title { font-weight:800; color:#0b1220; font-size:2rem; }
                .cr-sub { color:#6b7280; }

                .cr-card {
                    position:relative; background:#fff; border:1px solid #eef0f5; border-radius:18px;
                    padding:34px 22px 22px; height:100%;
                    box-shadow:0 6px 20px rgba(17,24,39,0.05); transition:.25s ease;
                }
                .cr-card:hover { transform:translateY(-6px); box-shadow:0 16px 34px rgba(37,99,235,0.14); border-color:#dbe6ff; }
                .cr-quote { position:absolute; top:14px; left:18px; font-size:2.4rem; color:#dbe6ff; line-height:1; }
                .cr-text { color:#374151; font-size:.95rem; margin:6px 0 14px; min-height:64px; }
                .cr-stars { color:#f5a623; font-size:.95rem; margin-bottom:14px; letter-spacing:2px; }
                .cr-user { display:flex; align-items:center; gap:12px; border-top:1px solid #f2f4f8; padding-top:14px; }
                .cr-avatar { width:48px; height:48px; border-radius:50%; object-fit:cover; border:2px solid #eef3ff; }
                .cr-name { font-weight:700; color:#0b1220; font-size:.95rem; }
                .cr-role { font-size:.8rem; color:#9aa1a9; }

                .cr-dots { position:static; margin-top:22px; }
                .cr-dots button { width:9px; height:9px; border-radius:50%; background:#cbd5e1; border:0; opacity:1; margin:0 4px; transition:.2s; }
                .cr-dots button.active { background:#2563eb; width:24px; border-radius:6px; }

                .cr-ctrl { width:46px; opacity:1; }
                .cr-ctrl-icon { width:42px; height:42px; border-radius:50%; background:#fff; color:#2563eb; box-shadow:0 4px 14px rgba(0,0,0,0.12); display:flex; align-items:center; justify-content:center; font-size:1.1rem; }
                .cr-ctrl:hover .cr-ctrl-icon { background:#2563eb; color:#fff; }
                @media (max-width: 575px){ .cr-ctrl{ display:none; } .cr-title{ font-size:1.6rem; } }
            `}</style>
        </div>
    );
};

export default CustomerReviews;
